import { ReactComponent as CloseSvg } from 'assets/img/close.svg';
import { ReactComponent as FolderIcon } from '../img/folder.svg';
import { FC } from 'react';
import styles from './FileInfoDisplay.module.scss';

interface FileInfoDisplayProps {
  file: File;
  onRemove: () => void;
  truncateFileName: (name: string, maxLength?: number) => string;
}

export const FileInfoDisplay: FC<FileInfoDisplayProps> = ({
  file,
  onRemove,
  truncateFileName,
}) => {
  return (
    <div className={styles.file} style={{ margin: '4px 0' }}>
      <div className={styles.fileInfoSelected}>
        <FolderIcon />
        <div className={styles.fileDetailsSelected}>
          <span className={styles.fileNameSelected} title={file.name}>
            {truncateFileName(file.name, 25)}
          </span>
          <span className={styles.fileDateSelected}>
            {new Date().toLocaleDateString('ru-RU')}
          </span>
        </div>
      </div>
      <CloseSvg onClick={onRemove} className={styles.file_icon} />
    </div>
  );
};
